import { useState, useEffect } from 'react';

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQueryList = window.matchMedia('(max-width: 767px)');
        setIsMobile(mediaQueryList.matches);

        const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        mediaQueryList.addEventListener('change', handler);
        return () => mediaQueryList.removeEventListener('change', handler);
    }, []);

    return isMobile;
};
